import React from 'react';
//import { View, StyleSheet, BackHandler, TouchableOpacity, Text , Dimensions } from 'react-native';
import { useTranslation } from "react-i18next";
import moment from "moment";
import { makeStyles } from "@mui/styles/";
import { Typography } from '@mui/material';
import firebase from "firebase";
//import { PDFReader }  from 'react-pdf-viewer'
import { useHistory, useParams } from 'react-router-dom';
import EmptyComponentRender from "../../components/EmptyComponentRender";
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Container from "@mui/material/Container";
import StoreText from '../../components/store/StoreText';
// import SearchScreen from '../SearchScreen/SearchScreen';
const useStyles = makeStyles({
  container: {
    flex:1,
    display: "flex",
    backgroundColor: '#fff',

  },
  descriptionHeader: {
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#dfe4fe",
    borderStyle: "solid",
  },
   storeText: {
    color: "#222",
    color: "green",
    fontWeight: "bold",
    marginLeft: 10,
    textDecorationLine: "underline",
    fontSize: 16,
  },
  details: {
    marginTop: 0,
    marginBottom: 0,
  },
  image: {
  
    resizeMode: 'contain',
  },
  itemContainer: {
   
    //marginTop: 20,
    display:"flex",
    alignContent:"center",
    justifyContent: 'center',
    alignItems: 'center',
  },
  discountExpText: { textAlign: "center", color: "gray", fontWeight: "400", fontSize: 13 },
});
const OfferDetails = ({  }) => {
  const [offer, setOffer] = React.useState(null);
  const [expiry, setExpiry] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const { t, i18n } = useTranslation();
  const diff = !!expiry ? moment().diff(expiry, 'days') * -1 : "";
  const { innerWidth: width, innerHeight: height, screen } = window;
  const imageW = width /3;
  const imageH = imageW;
  const styles = useStyles();
  const params = useParams();
  
  const loadData = async () => {
    if ( params && params?.id && params?.id !="") {
     const offerData = await (await firebase.firestore().collection("offers").doc(params?.id).get()).data();
       setOffer(offerData);
       const expDate=offerData?.expireAt?new firebase.firestore.Timestamp( offerData?.expireAt?.seconds, offerData?.expireAt?.nanoseconds):undefined;
       if(expDate){
        setExpiry(expDate?.toDate() ?? undefined);
       }
      
      setLoading(false);
    }else{
      setOffer(null);
      setLoading(false);
    }
};

React.useEffect(()=>{
  loadData();
},[params]);

  return (
    <div className={styles.container}>
          <Container sx={{ py: 2 }} maxWidth="lg">
       {loading && <Box sx={{ pt: 0.5 }}>
            <Skeleton variant="rectangular" width={"100%"} height={"60%"} />
            <Skeleton />
            <Skeleton width="60%" />
          </Box> }
  {offer&&!loading&&<div className={styles.mainContainer}>
        {!offer.link &&<div style={{paddingLeft:20,paddingRight:20 ,}}>
        {!!offer && 
            <div className={styles.itemContainer} style={{
              width: "100%" ,
              height: imageH ,
              flexDirection:"row",
              flex: 1,
              justifyContent:"center",
              display:"flex",

            }}>
              <div >
              <img
              className={styles.image}
                style={{
                  left:0,
                  right:0,
                  width: imageW,
                  height: imageH,
                }}
                src={offer.image && offer.image != '' ? offer.image : require("../../assets/placeholder-image.png")}
              />
              </div>
            </div>}
          <Typography style={{ color: 'black', marginTop: 20, textAlign: 'center' , fontSize:20}}>{i18n.language == 'ar' ? offer.titleAr : offer.titleEn}</Typography>
          {!!offer.storeInfo &&
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: 20 }} >
              <Typography className={styles.details} style={{alignSelf : "center"}}>{t("product.store")}</Typography>
              <StoreText imageStyle={ {marginLeft:10,width: 60, height: 60,  borderRadius: 100,resizeMode: 'contain' }} image={offer.storeInfo?.image} storeID={offer.storeId} text={offer.storeInfo[i18n.language == 'ar' ? "nameAr" : "nameEn"] ?? ""}/>
            </div>}
          {!!expiry &&
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", }} >
              <Typography className={styles.discountExpText}>{t('product.expire').replace('{days}', diff)} </Typography>
            </div>}
          <Typography style={{ fontSize: 18, marginTop: 16 }}>
            {t('offers.offerDescription')}
          </Typography>
          {!!offer.description &&
            <div style={{ backgroundColor: "#fff", marginTop: 10 }}>
              <div style={{ padding: 10 }}>
                <Typography >
                  { offer.description}
                </Typography>
              </div>
            </div>}
        </div>}
      </div>}
      {!offer && !loading&&<EmptyComponentRender/>}
     
      {/* https://www.africau.edu/images/default/sample.pdf */}
      </Container>
    </div>
  );
}


export default OfferDetails;